// Home-org storage used by the SYSOP back-office switcher and the reseller
// switcher. Both need to remember which org the user came from so the
// acting-as banner and return-home button can render after the token has
// already been swapped to the target org.
//
// SYSOP uses prefix 'sysop'; reseller uses prefix 'reseller'. Keeping a
// stable, prefix-namespaced key avoids cross-contamination between flows.

export interface HomeOrg {
  orgId: string;
  orgName: string;
}

function key(prefix: string, uid: number | string) {
  return `scriptix_${prefix}_home_org_${uid}`;
}

export function getHomeOrg(
  prefix: string,
  uid: number | string
): HomeOrg | null {
  try {
    const raw = localStorage.getItem(key(prefix, uid));
    return raw ? (JSON.parse(raw) as HomeOrg) : null;
  } catch {
    return null;
  }
}

export function saveHomeOrg(
  prefix: string,
  uid: number | string,
  orgId: string,
  orgName: string
): void {
  try {
    localStorage.setItem(
      key(prefix, uid),
      JSON.stringify({ orgId, orgName } satisfies HomeOrg)
    );
  } catch {
    /* localStorage may be unavailable (Safari private mode, quota). */
  }
}

export function clearHomeOrg(prefix: string, uid: number | string): void {
  try {
    localStorage.removeItem(key(prefix, uid));
  } catch {
    /* localStorage may be unavailable (Safari private mode, quota). */
  }
}
